import styled from 'styled-components';
import featureBackground from '../../../assets/images/feature-background.png';
import featureBackgroundMb from '../../../assets/images/feature-background-mb.png';

export const SectionContainer = styled.section`
  height: 780px;
  width: 100%;
  background-color: #FF7A00;
  background-image: linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.15)), url(${featureBackground});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: scroll;
  display: flex;
  position: relative;
  
  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
    background-position: center center;
    background-image: linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.15)), url(${featureBackgroundMb}); /* Imagem mobile */
  }
`;

export const LeftContainer = styled.div`
  width: 50%;
  
  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
  }
`;

export const RightContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 2rem;
  position: relative;
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 2rem 1.5rem;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  position: relative;
  padding-top: 70px; 
  
  @media (max-width: 768px) {
    padding-top: 60px;
  }
`;

export const LogoContainer = styled.div`
  position: absolute;
  top: 0;
  left: -15px; 
  margin-bottom: 2rem;
  
  img {
    height: 50px; 
  }
  
  @media (max-width: 768px) {
    left: -10px;
    
    img {
      height: 40px;
    }
  }
`;

export const Title = styled.h2`
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 2rem;
  color: #fff;
  max-width: 660px;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 0.7rem;
  color: #fff;
  opacity: 0.9;
  max-width: 520px;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
    margin-bottom: 1.2rem;
  }
`;

export const SubDescription = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 0.7rem;
  color: #fff;
  opacity: 0.9;
  max-width: 520px;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
    margin-bottom: 1.2rem;
  }
`;

export const AdditionalInfo = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  color: #fff;
  opacity: 0.9;
  width: 100%;
  margin-top: 0.5rem;
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;